module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-16.f9deef19.png";